import { useUnifiedDashboardData } from './useUnifiedDashboardData';
import type { DashboardStats, UniqueFilterValues } from './useUnifiedDashboardData';

export type { DashboardStats, UniqueFilterValues };

export const useSairamUltimaSemanaData = () => {
  return useUnifiedDashboardData('sairam-ultima-semana');
}; 